import Io from 'socket.io-client';

const WEBSOCKET_URL = import.meta.env.VITE_WS_API_URL ?? '';

let socket = Io(WEBSOCKET_URL, {
  reconnection: true,
  reconnectionDelay: 100,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: Infinity,
  transports: ['websocket']
});

const getSocket = () => {
  if (!socket) {
    socket = Io(WEBSOCKET_URL, {
      reconnection: true,
      reconnectionDelay: 100,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: Infinity,

      transports: ['websocket']
    });
    // socket.io.on('reconnect', ())
    socket.on('hello', data => console.log(`Hello data ${data}`));
  }

  return socket;
};

socket.io.on('close', () => console.log('socket connection closed'));
socket.io.on('reconnect_attempt', () => console.log('socket reconnect attempt'));
socket.io.on('reconnect_failed', () => console.log('socket reconnect failed'));
socket.io.on('reconnect', () => console.log('socket reconnect'));

export default getSocket;
